import * as React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import './SelfinspectDetails.css';
import ViewPhotos from '../ViewPhotos/ViewPhotos';
import { postToController } from '../../../actions/apiActions';
import { hideLoadingScreen, showLoadingScreen } from '../../../actions/fullscreenActions';
import { toggleSelfInspectPhotos, toggleHasError } from '../../../actions/selfInspectActions';
import { SA_COUNTRY_ID } from '../../../constants/internationalization';

class SelfinspectDetails extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            photoData: null,
        };
        this.handleShowSelfInspectPhotos = this.handleShowSelfInspectPhotos.bind(this);
        this.getInspectionDetails = this.getInspectionDetails.bind(this);
    }

    async componentDidMount() {
        await this.getInspectionDetails();

    }
    async handleShowSelfInspectPhotos() {
        this.props.dispatchToggleHasError(false);
        this.props.dispatchToggleSelfInspectPhotos(false);
    }

    async getInspectionDetails() {
        this.props.dispatchShowLoadingScreen();
        await postToController(this.props.dispatch, 'GetInspectionDetails', JSON.stringify({ Parameter: this.props.profile.selectedPersonalCover.riskItems[0].riskItemId })).then(async (response) => {
            if (response && response.imageList && response.imageList.length > 0) {
                await this.setState({ photoData: response });
             
                this.props.dispatchToggleHasError(false);
              
                this.props.dispatchHideLoadingScreen();
                return true;
            } else {
                this.props.dispatchToggleHasError(true);
                this.props.dispatchHideLoadingScreen();
                return false;
            }
        })
    }
    async handleExcessDropdownToggle(e: any) {
        await this.setState({
            selectedExcessDropdown: !this.state.selectedExcessDropdown
        });
    }

    async handleShowMore(e: any) {
        await this.setState({
            showMore: !this.state.showMore
        });
    }
     
    render() {
        const cover = this.props.profile.selectedPersonalCover;
        
        return (
            <>
            {!this.props.selfInspect.hasError &&
                    <div id="SelfInspectDetails" className="new-ssp-faq-block mr-15px ml-15px mb-20px">
                    <div className="accordion-banner">
                        <h3>{cover.productName.toLowerCase() === "car" ? 'Car' : 'Motorbike'} details</h3>
                    </div>
                                <Card.Body>
                                    <div className="form-group row noma">
                                        <label className="col-sm-6 nopa nopa col-form-labell">Vin no.</label>
                                        <div className="col-sm-6 nopa nopa">
                                <p className="form-control-plaintext  text-sm-left text-md-right">{this.state.photoData && this.state.photoData?.vinNumber}</p>
                                        </div>
                                    </div>
                                    <div className="form-group row noma">
                                        <label className="col-sm-6 nopa col-form-label">Reg no.</label>
                                        <div className="col-sm-6 nopa nopa">
                                <p className="form-control-plaintext  text-sm-left text-md-right">{this.state.photoData && this.state.photoData?.registrationNumber}</p>
                                        </div>
                                    </div>
                                    <div className="form-group row noma">
                                <label className="col-sm-6 nopa col-form-label">Licence no.</label>
                                        <div className="col-sm-6 nopa nopa">
                                <p className="form-control-plaintext  text-sm-left text-md-right">{this.state.photoData && this.state.photoData?.licenseNumber}</p>
                                        </div>
                                    </div>
                                    <div className="form-group row noma">
                                        <label className="col-sm-6 nopa col-form-label">Engine no.</label>
                                        <div className="col-sm-6 nopa nopa">
                                <p className="form-control-plaintext  text-sm-left text-md-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.engineNumber}</p>
                                        </div>
                                    </div>
                                    <div className="form-group row noma">
                                      <label className="col-sm-6 nopa col-form-label">Manufacturer</label>
                                        <div className="col-sm-6 nopa">
                                <p className="form-control-plaintext  text-sm-left text-md-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vehicleMake}</p>
                                        </div>
                                    </div>
                                    <div className="form-group row noma">
                                        <label className="col-sm-6 nopa col-form-label">Model</label>
                                        <div className="col-sm-6 nopa">
                                <p className="form-control-plaintext  text-sm-left text-md-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vehicleModel}</p>
                                        </div>
                                    </div>
                                </Card.Body>

                    <div className="accordion-banner mt-15px">
                        <h3>{cover.productName.toLowerCase() === "car" ? 'Car' : 'Motorbike'} photos</h3>
                    </div>
                        <Card.Body className="cursor-pointer">

                            {this.state.photoData?.imageList &&
                                <ViewPhotos photoData={this.state.photoData?.imageList} />
                            }
                        </Card.Body>
                </div>
            }
                {this.props.selfInspect.hasError &&

                    <div className="container text-center font-size-16px font-weight-normal mb-0px">
                    <img className="mt-20px" src="Images/FNOL/Notifications.svg" alt="" />
                    <h3 className="mt-10px mb-0px">Oops!</h3>
                    <p className ="mt-10px mb-0px">It looks like your self-inspection details didn’t load.</p>
                    <p className="mb-0px">Please try again in a few minutes or pop an email to</p>
                            <a className="red-link mb-0px" href={this.props.profile.countryId === parseFloat(SA_COUNTRY_ID) ? "mailto:clientcare@kingprice.co.za" : "mailto:clientcare@kingprice.co.na"} target="_blank">
                        {this.props.profile.countryId === parseFloat(SA_COUNTRY_ID) ? "clientcare@kingprice.co.za" : "clientcare@kingprice.co.na"}
                    </a>
                        <div className="col-lg col-12 nopa text-center mt-20px mb-15px">
                            <button className="btn btn-solid-red w-sm-100 view-self-inspect-back mb-20px" onClick={this.handleShowSelfInspectPhotos}>Back to personal policy</button>
                        </div>
                </div>
                }
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.auth,
        selfInspect: state.selfInspect
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchShowLoadingScreen: () => dispatch(showLoadingScreen()),
        dispatchHideLoadingScreen: () => dispatch(hideLoadingScreen()),
        dispatchToggleSelfInspectPhotos: (value) => dispatch(toggleSelfInspectPhotos(value)),
        dispatchToggleHasError: (value) => dispatch(toggleHasError(value))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SelfinspectDetails);